export default "__VITE_ASSET__932604b3__"